import { render, staticRenderFns } from "./PDTFolks.vue?vue&type=template&id=302ca8ce&scoped=true&"
import script from "./PDTFolks.vue?vue&type=script&lang=ts&"
export * from "./PDTFolks.vue?vue&type=script&lang=ts&"
import style0 from "./PDTFolks.vue?vue&type=style&index=0&id=302ca8ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302ca8ce",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VContainer,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('302ca8ce')) {
      api.createRecord('302ca8ce', component.options)
    } else {
      api.reload('302ca8ce', component.options)
    }
    module.hot.accept("./PDTFolks.vue?vue&type=template&id=302ca8ce&scoped=true&", function () {
      api.rerender('302ca8ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/access-permissions/components/PDTFolks.vue"
export default component.exports